
let eResults = {
    Ok: 0,
    GeneralError: 1,
    InvalidParams: 2,
    AuthRequestAlreadyInprogress: 3,
    ExpiredTransaction: 4,
    UserCancel: 5,
    CertificateErr: 6,
    Pending: 7,
    Complete: 8,
    Failed: 9,
    UnderAge: 10,
    FinalStatusWasAlreadyCollected: 127
};


const eSubBrand = {
    sportSe: 131,
    pokerSe: 130,
    casinoSe: 129
}

const eProductPackage = {
    DefaultAndroidWrapper: 95,
    AndroidGPWrapper: 100
}

const localStorageKeys = {
    bankIdValue: 'bankId'
}

export { eResults, eSubBrand, eProductPackage, localStorageKeys };